import { render } from "./FormCreateOrUpdate.vue?vue&type=template&id=b1a42858&scoped=true"
import script from "./FormCreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./FormCreateOrUpdate.vue?vue&type=script&lang=js"

import "./FormCreateOrUpdate.vue?vue&type=style&index=0&id=b1a42858&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b1a42858"

export default script